import { dataProps, priceItemProps } from './properties'

export const setFabricPriceSlabList = (state, payload) => {
    state.list = payload
}    

export const setFabricPriceSlabData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.price_category_list.length === 0) {
        state.props.price_category_list = [JSON.parse(JSON.stringify(priceItemProps))]
    } else if(payload.copy) {
        state.props.price_category_list.forEach(element => {
            element.id = 0
        })
    }

    let key = 0
    state.props.price_category_list.forEach(element => {
        element.key = key
        key ++
    })
} 

export const addNewFabricPriceSlabItemRow = state => {

    let key = 0
    state.props.price_category_list.push(JSON.parse(JSON.stringify(priceItemProps)))

    state.props.price_category_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('tailoring_item_sub_category_id'+(key-1)).focus()
    }, 200);

}

export const removeFabricPriceSlabItemRow = (state, payload) => {

    let key = 0

    state.props.price_category_list.splice(payload, 1)

    if(state.props.price_category_list.length === 0) {
        state.props.price_category_list = [JSON.parse(JSON.stringify(priceItemProps))]
    }

    state.props.price_category_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const resetFabricPriceSlabData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/fabricPriceSlab/mutations.js